import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { paths } from '../../paths'

export const budgetdivisionscalendarpage: JSX.Element[] = [
  <Route
    component={lazy(async () => {
      const { BudgetDivisionCalendarPage } = await import(
        /* webpackChunkName: "Login" */ '../../../components/pages/private/BudgetDivisionCalendarPage'
      )
      return {
        default: BudgetDivisionCalendarPage,
      }
    })}
    exact
    key={paths.budgetDivisionCalendar}
    path={paths.budgetDivisionCalendar}
  />,
]
